import { atom, useAtom } from "jotai";
import { useEffect } from "react";
import { startRudderstackSession } from "./rudderstack";

const sessionStartedAtom = atom(false);

export const useInitRudderstackSession = (hasConsent: boolean) => {
  const [isSessionStarted, setIsSessionStarted] = useAtom(sessionStartedAtom);

  useEffect(() => {
    try {
      if (!hasConsent || isSessionStarted) {
        return;
      }

      startRudderstackSession(hasConsent);
      setIsSessionStarted(true);
    } catch (error) {
      console.error(error);
    }
  }, [hasConsent, isSessionStarted, setIsSessionStarted]);

  return isSessionStarted;
};
